function tiakPlugin(options) {
    var that = this;
    var handle;
    var isPaused = false;
    var videoWidth = 0;
    var videoHeight = 0;
    var screenWidth = window.screen.width;
    var screenHeight = window.screen.height;
    var pstStart = null;
    var pstEnd = null;
    options.channelID = options.channelID || 26;
    options.sitename = options.sitename || 'tv2-tr';
    options.tiakCategory = options.live ? 'teve2-live' : 'teve2-programs';
    var player = that;
    switch (options.pqType) {
        case 'Quark':
            player = that.player();
            break;
        case 'RadiantMP':
        case 'Dailymotion':
            player = that;
            break;
    }
    var getVideoDimensions = function () {
        switch (options.pqType) {
            case 'Quark':
                videoWidth = player.el_.clientWidth;
                videoHeight = player.el_.clientHeight;
                break;
            case 'RadiantMP':
                videoWidth = player.getPlayerWidth();
                videoHeight = player.getPlayerHeight();
                break;
            case 'Dailymotion':
                videoWidth = player.el_.clientWidth;
                videoHeight = player.el_.clientHeight;
                break;
        }
    };
    getVideoDimensions();
    var getPlayStates = function () {
        var playStates;
        switch (options.pqType) {
            case 'Dailymotion':
            case 'Quark':
                playStates = player.currentTime();
                break;
            case 'RadiantMP':
                playStates = options.live
                    ? (isPaused ? null : new Date().getTime() / 1000)
                    : player.getCurrentTime() / 1000;
                break;
            default:
                playStates = 0;
        }
        return playStates;
    };
    var handleResize = function () {
        var innerWidth = window.innerWidth, innerHeight = window.innerHeight;
        screenWidth = innerWidth;
        screenHeight = innerHeight;
        getVideoDimensions();
    };
    window.addEventListener("resize", handleResize);
    var playerIsLoaded = function () {
        var sensors = new SpringStreams(options.sitename);
        sensors.debug = function (v) {
            console.log("Kantar DEBUG →", v);
        };
        window.addEventListener('tv2_unload', function () {
            sensors && sensors.unload();
        });
        var adapter = {
            getMeta: function () { return ({
                pl: options.pqType,
                plv: player.version,
                sx: videoWidth,
                sy: videoHeight,
            }); },
            getPosition: getPlayStates,
            getDuration: function () { return options.live ? 0 : Math.round(player.duration()); },
        };
        var getDeviceTypeForTiak = function () {
            var ua = navigator.userAgent;
            if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
                return "tablet";
            }
            if (/Mobile|iP(hone|od|ad)|Android|BlackBerry|IEMobile|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(ua)) {
                return "mobile";
            }
            return "pc";
        };
        var deviceType = getDeviceTypeForTiak();
        var desc = {
            sx: screenWidth,
            sy: screenHeight,
            stream: options.live ? "live/" + options.channelID : "od/" + options.channelID,
            ct: deviceType
        };
        // ✅ fbtime doğru formatta dönüştürülüyor
        if (!options.live && options.broadcastScheduleTime && options.broadcastScheduleTime != "0") {
            const parsedDate = new Date(Number(options.broadcastScheduleTime) * 1000);
            if (!isNaN(parsedDate.getTime())) {
                desc.fbtime = Math.floor(parsedDate.getTime() / 1000);
            }
            else {
                console.warn("Geçersiz broadcastScheduleTime:", options.broadcastScheduleTime);
            }
        }
        player.subscribe('play', function () {
            isPaused = false;
            if (!pstStart) {
                pstStart = Math.floor(Date.now() / 1000);
                console.log("▶️ pst start:", pstStart);
            }
        });
        player.subscribe('pause', function () {
            isPaused = true;
            sensors.doUpdate();
        });
        player.subscribe('ended', function () {
            pstEnd = Math.floor(Date.now() / 1000);
            console.log("⏹️ pst end:", pstEnd, "| Süre:", pstEnd - pstStart, "saniye");
            if (handle)
                handle.stop();
        });
        handle = sensors.track(options.tiakCategory, desc, adapter);
    };
    player.one('loadedmetadata', playerIsLoaded);
}
//# sourceMappingURL=plugin.js.map